import React, { useState, useEffect } from 'react'
import { Layout, Button } from 'antd'
import './Main.scss'
import { BrowserRouter as Router } from 'react-router-dom'
import Logo from '../../assets/images/cerberus_logo.png'
import { PermissionService } from 'services/PermissionService'
import Coroutine from 'react-coroutine'
import { LoadingFactory as LoadingFactory, LOADING_TYPES } from 'components/LoadingFactory'
import { UserData } from 'models/Blip/Index'
import { loginRequest } from 'connection/AuthConfig';
import { useIsAuthenticated, useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { callMsMember } from 'services/AzureAdService';
import { AccountInfo } from '@azure/msal-browser';
import { HubspotCerberusClient } from 'connection/HubspotCerberusClient'
import { ClientAuthError } from '@azure/msal-common';
import { MainContentPage } from './MainContentPage';
import { UserDataSingleton } from 'services/UserDataSingleton';
import { getAccessToken } from 'services/AzureLoginService';

const { Footer } = Layout
interface MainProps {
    login: Function;
    isLoading: Boolean;
    userAuth: UserData;
}

const AsyncContent = Coroutine.create(
    async function* ({ login, isLoading, userAuth }: MainProps) {
        yield <LoadingFactory type={LOADING_TYPES.Fullscreen} />
        try {
            return (
                <>
                    <AuthenticatedTemplate>
                        {
                            !isLoading ? (
                                <Router>
                                    <MainContentPage userAuth={userAuth} />
                                </Router>
                            ) : <LoadingFactory type={LOADING_TYPES.Fullscreen} />
                        }
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                        <div className="bg-login" style={{ backgroundColor: "blue" }}>
                        </div>
                        <div className="first-login" style={{ paddingTop: 50, paddingLeft: 250, paddingRight: 250, paddingBottom: 250 }}>
                            <div className="flex flex-column" style={{ alignItems: "center", justifyContent: "center", border: '2px solid black', borderRadius: 6 }}>
                                <div className="logo" style={{ maxWidth: 400 }} >
                                    <img src={Logo} alt="Cerberus Logo" />
                                </div>
                                <div style={{ paddingTop: "20px" }} >
                                    <Button size='large' type='primary' style={{ borderWidth: '2px solid black' }} onClick={() => { login(); }}>
                                        Login
                                    </Button>
                                </div>
                                <Footer className="tc" style={{ background: "white" }}>Cerberus ©{new Date().getFullYear()}</Footer>
                            </div>
                        </div>
                    </UnauthenticatedTemplate>
                </>
            )
        } catch (e) {
            console.error(e)
            return <h1>Error while connecting</h1>
        }
    }
)

export const Main = () => {
    const { instance, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [userAuth, setUserAuth] = useState<UserData>(null);

    useEffect(() => {
        if (isLoading) {
            updateConfigurations();
        }
    }, [isLoading, userAuth, isAuthenticated])

    const updateConfigurations = async () => {
        await HubspotCerberusClient.setParamValues();

        await PermissionService.setIsDevelopment();
        if (isAuthenticated && !userAuth) {
            try {
                let userData = await requestInfo() as UserData;
                UserDataSingleton.setInstance(userData);
                if (userData) {
                    setUserAuth(userData);
                    await PermissionService.setUserPermissions(userData.groups);
                }
                setIsLoading(false);
            } catch (e) {
                console.error(e);
            }
        };
    }

    const login = async () => {
        try {
            instance.loginRedirect(loginRequest);
        } catch (error) {
            console.error(error);
        }
    }

    const requestInfo = async () => {
        const account = accounts[0] as AccountInfo;
    
        try {
            const accessToken = await getAccessToken(instance, account, loginRequest);
    
            const response = await callMsMember(accessToken);
            const userGroups = response.value.map(element => element);
            const userAuth = {
                email: account.username,
                name: account.name,
                groups: userGroups
            } as UserData
    
            return userAuth;
        } catch (error) {
            console.error(error);
            if (ClientAuthError) {
                login();
            }
        }
    }

    return <AsyncContent isLoading={isLoading} login={login} userAuth={userAuth} />
}
